import { render, staticRenderFns } from "./SaveAdditionaForm.vue?vue&type=template&id=95fadce0&"
import script from "./SaveAdditionaForm.vue?vue&type=script&lang=js&"
export * from "./SaveAdditionaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports